import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook to handle navigation messages from service worker
 * Used when notification is clicked and app needs to navigate
 */
export const useServiceWorkerNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "NAVIGATE" && event.data?.url) {
        navigate(event.data.url);
      }
    };

    navigator.serviceWorker?.addEventListener("message", handleMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener("message", handleMessage);
    };
  }, [navigate]);
};
